var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19727 7.10894C1.19727 5.11466 1.19727 4.11726 1.81707 3.49798C2.43635 2.87817 3.43376 2.87817 5.42803 2.87817H7.54342C9.5377 2.87817 10.5351 2.87817 11.1544 3.49798C11.7742 4.11726 11.7742 5.11466 11.7742 7.10894V8.16664C11.7742 10.1609 11.7742 11.1583 11.1544 11.7776C10.5351 12.3974 9.5377 12.3974 7.54342 12.3974H5.42803C3.43376 12.3974 2.43635 12.3974 1.81707 11.7776C1.19727 11.1583 1.19727 10.1609 1.19727 8.16664V7.10894Z",
    stroke: "#FF7A00",
    strokeWidth: 1.05769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8418 2.87823V2.08496M9.13026 2.87823V2.08496",
    stroke: "#FF7A00",
    strokeWidth: 1.05769,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86553 10.2821C9.30365 10.2821 9.6588 9.92694 9.6588 9.48883C9.6588 9.05072 9.30365 8.69556 8.86553 8.69556C8.42742 8.69556 8.07227 9.05072 8.07227 9.48883C8.07227 9.92694 8.42742 10.2821 8.86553 10.2821Z",
    stroke: "#FF7A00",
    strokeWidth: 1.05769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46094 5.52246H11.509",
    stroke: "#FF7A00",
    strokeWidth: 1.05769,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_3086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.6923,
    height: 12.6923,
    fill: "white",
    transform: "translate(0.140625 0.762695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartControlIcon);
export default __webpack_public_path__ + "static/media/smartControlIcon.5cb05fcd15cc4d92a225f4331793e232.svg";
export { ForwardRef as ReactComponent };